import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getDashboardRequestStatusesSummaryExport } from '@api/dashboardPO';

import { IExportFileDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { ESnackbarTypes } from '@enums/common';

import { DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateDashboardAssetStatusesExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportDashboardStatusesSummary,
		isLoading: isLoadingDashboardStatusesSummary,
	} = useMutation<IExportFileDTO>({
		mutationKey: [DASHBOARD_REQUEST_STATUSES_SUMMARY_BY_STATUS_EXPORT],
		mutationFn: getDashboardRequestStatusesSummaryExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportDashboardStatusesSummary,
		isLoadingDashboardStatusesSummary,
	};
}
